import ULThemeLink from "@/components/ULThemeLink";
import { getConsoleSignupUrl } from "@/utils/helpers/consoleUrls";

import { useLoginManager } from "../hooks/useLoginManager";

function Footer() {
  const { texts, locales, signupLink } = useLoginManager();

  // signupLink is only used to gate visibility — when Auth0 reports signup is
  // disabled for the tenant, no link is shown. When it is enabled, the link
  // points at the Lexara console's signup flow instead of Auth0's own screen.
  if (!signupLink) {
    return null;
  }

  return (
    <div className="mt-6 text-left">
      <span className="text-sm theme-universal:text-body-text theme-universal:text-(length:--ul-theme-font-body-text-size) theme-universal:font-body-text">
        {texts?.signupActionText || locales?.footer?.signupActionText}{" "}
      </span>
      <ULThemeLink href={getConsoleSignupUrl()}>
        {texts?.signupActionLinkText || locales?.footer?.signupActionLinkText}
      </ULThemeLink>
    </div>
  );
}

export default Footer;
